import { CitoBasePreset } from './Cito.PrimeNG.theme.base';

export const CitoDoePreset = CitoBasePreset;
